<template>
  <div class="avatarSection text-md-left text-center" :class="isEditing ? 'isEdit' : '' ">
    <div class="editAvatarWrapper">
      <AvatarComponent
        size="145"
        hasBorder
        :url="picture"
      />
      <v-btn
        v-if="isMine"
        elevation="2" icon class="avatar-input"
        @click="$refs.fileInput.click()"
      >
        <v-icon>far fa-camera</v-icon>
      </v-btn>
    </div>
    <input
      v-show="false"
      ref="fileInput"
      type="file"
      name="image"
      accept="image/*"
      @change="onChange"
    />
    <InputCrop
      title="Avatar Uploader"
      :file="fileUpload"
      ref="AvatarUploader"
      @cropped="onCropped"
      :closeOnCrop="false"
      :cropOptions="{width: 150, height: 150, imageSmoothingQuality: 'high'}"
    />
    <div
      class="boxedContent pt-md-16 pt-4 mt-md-10 mt-0"
      :style="user ? 'width: 39%;' : 'width: 50%;'"
    >
      <strong class="black--text text-md-h4 text-h5 font-weight-bold">{{
        username || fullName
      }}</strong>
      <div class="actionSection mt-2">
        <div v-if="isEditing">
          <v-form ref="form" lazy-validation>
            <v-textarea
              outlined
              background-color="#fff"
              name="editDescription"
              :placeholder="$gettext('Description')"
              :rules="minCharactersRules"
              :counter="100"
              @keypress="onlyNumber"
              @paste="onlyNumber"
              rows="3"
              v-model="description"
            >
            </v-textarea>
          </v-form>
          <v-row>
            <v-col cols="12" class="text-right">
              <v-btn
                large
                @click="isEditing = !isEditing"
                style="background-color: #e2e2e2; color: rgba(0, 0, 0, 0.87)"
                class="font-weight-bold text-none elevation-0 mr-3"
              >
                <translate>Cancel</translate>
              </v-btn>
              <v-btn
                large
                type="submit"
                color="primary"
                style="color: #fff"
                @click.prevent="onSubmit"
                class="font-weight-bold text-none elevation-0"
              >
                <translate>Save</translate>
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <p class="descriptionBox mb-2">{{ note }}</p>
          <ButtonEdit
            @click="isEditing = !isEditing"
            v-if="isMine"
            :text="$gettext('Edit Short Bio')"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ButtonEdit from "@/components/Buttons/ButtonEdit";
import InputCrop from "@/components/Forms/InputCrop";
export default {
  name: "Avatar",
  props: {
    url: {type: String, default: null},
    username: {type: String, default: null},
    note: {type: String, default: null},
    isMine: { type: Boolean, default: false }
  },
  components: { ButtonEdit, InputCrop },
  data: () => ({
    isEditing: false,
    description: "",
    maxdescription: "",
    minCharactersRules: [(v) => v.length <= 100 || "100 characters remaining"],
    fileUpload: null
  }),
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    fullName() {
      return this.user.firstName + " " + this.user.lastName;
    },
    picture() {
      return this.isMine ? this.user.picture : this.url
    }
  },
  watch: {
    description(val) {
      if (val && val.length > 100) {
        this.description = this.description.substring(0, 100);
      }
    }
  },
  methods: {
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (this.description.length >= 100) {
        $event.preventDefault();
      }
    },
    async onSubmit() {
      if (this.$refs.form.validate()) {
        this.isEditing = !this.isEditing;
        let data = { shortBio: this.description };
        let result = await this.$store.dispatch("descriptionUpdate", data);
        if (result.error) {
          this.$toast.alert(result.error.message);
        } else {
          this.$toast.success(`Update success`);
          this.$store.commit("setUserData", data);
        }
      }
    },
    async onCropped(file) {
      let result = await this.$store.dispatch("avatarUpdate", file);
      this.$refs.AvatarUploader.dialog = false
      this.$refs.fileInput.reset()
      if (result.error) {
        this.$toast.alert(`${result.error.message}`);
      } else {
        this.$toast.success(`Update success`);
      }
    },
    onChange(e) {
      let vm = this;
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      let reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (e) => {
        vm.fileUpload = e.target.result; // change data image
        vm.$refs.AvatarUploader.open(true); // show popup
      };
    },
  },
};
</script>
